class Map {
  public mapElement: HTMLElement | null;

  constructor() {
    this.bindings = this.bindings.bind(this);
  }

  cache() {
    this.mapElement = document.querySelector('.js-map');
  }

  bindings() {
    if (this.mapElement) {
      if (!localStorage.getItem('complyConsentManager__madeDecision')) {
        this.mapElement.style.backgroundImage = 'url(' + this.mapElement.dataset.placeholder + ')';
        this.mapElement.style.setProperty('--placeholder', 'url(' + this.mapElement.dataset.placeholder + ')' || '');
      } else {
        const status = JSON.parse(localStorage.getItem('complyConsentManager__categoryAcceptanceStatus') || '');

        if (status && !status.advanced.MAPS) {
          this.mapElement.style.backgroundImage = 'url(' + this.mapElement.dataset.placeholder + ')';
          this.mapElement.style.setProperty('--placeholder', 'url(' + this.mapElement.dataset.placeholder + ')' || '');
        }
      }
    }

    window.addEventListener('ccm:event:third-party-product-accepted', (e) => {
      // @ts-ignore
      if(e.detail.title === 'SnazzyMaps') {
        if (this.mapElement) {
          this.mapElement.style.setProperty('--placeholder', '');
        }
      }
    })
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default Map;
